import {
  Text,
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { RoundDetailsAnimationWrapper } from "../RoundDetailsAnimationWrapper";
import { BookingDiscountItem } from "./BookingDiscountItem";
import { PunchPassSummary } from "./PunchPassSummary";
import { PunchPassSummary_Booking$key } from "./__generated__/PunchPassSummary_Booking.graphql";

export type BookingPunchPassSummaryInfo = {
  hasValidPunchPass: boolean;
  hasPunchPassApplied: boolean;
  validPunchPassCount: number;
  invalidPunchPassCount: number;
  totalPunchPassCount: number;
};

type BookingChargeItemListProps = {
  bookingChargeGroups: {
    id: string;
    lineItems: { id: string; name: string; total: number }[];
    discounts: { id: string; name: string; appliedAmount: number }[];
  }[];
  viewMore: boolean;
  punchPassInfo: BookingPunchPassSummaryInfo;
  bookingFragmentRef: PunchPassSummary_Booking$key | null;
};

export const BookingChargeItemList = ({
  bookingChargeGroups,
  viewMore,
  punchPassInfo,
  bookingFragmentRef,
}: BookingChargeItemListProps) => {
  const { currencySymbol } = useGetClubCurrency();

  const shouldShowPunchPassSummary = punchPassInfo.totalPunchPassCount > 0;

  if (!bookingChargeGroups?.length && !shouldShowPunchPassSummary) return null;

  return (
    <RoundDetailsAnimationWrapper enterFrom="bottom" hide={!viewMore}>
      <Box>
        {bookingChargeGroups?.map((group) => (
          <VStack key={group.id} gap={2}>
            {group.lineItems.map((lineItem) => (
              <HStack
                key={lineItem.id}
                justifyContent="space-between"
                style={{ marginLeft: 36 }}
                alignItems="center"
              >
                <Text variant="mainBaseMedium" color="text-primary">
                  {lineItem.name}
                </Text>
                <Text
                  variant="mainBaseMedium"
                  color="text-primary"
                  testID={`booking-fee-${lineItem.name}`}
                >
                  {`${currencySymbol}${ConvertCentsToDollars(
                    lineItem.total ?? 0
                  )}`}
                </Text>
              </HStack>
            ))}
            {group.discounts.map((discount) => (
              <BookingDiscountItem key={discount.id} discount={discount} />
            ))}
          </VStack>
        ))}
        <PunchPassSummary
          shouldShowPunchPassSummary={shouldShowPunchPassSummary}
          punchPassInfo={punchPassInfo}
          bookingFragmentRef={bookingFragmentRef}
        />
      </Box>
    </RoundDetailsAnimationWrapper>
  );
};
